














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CardRow from '@/components/CardRow.vue';
import { REVERSE_TRANSACTION } from '../../../store/financeAccount';
import { ReverseTransaction, Transaction } from '../../../types';
import { ApiResponse } from '@/components/types';
import { createReverseTransaction } from '../../../model';

const FinanceAccount = namespace('listOfAssets/financeAccount');

@Component({
  components: { CardRow }
})
export default class ReverseTransactionDialog extends Vue {
  @Prop({ type: Object }) transaction!: Transaction | null;

  @FinanceAccount.Action(REVERSE_TRANSACTION) reverseTransaction!: (value: ReverseTransaction) => Promise<ApiResponse>;

  error: any = null;
  dialog: boolean = false;
  value: ReverseTransaction | null = null;

  @Watch('dialog')
  watchDialogClosed(value: boolean) {
    if (value !== false) return;

    setTimeout(() => {
      this.error = null;
      this.dialog = false;
      this.value = null;
      this.$emit('update:transaction', null);
    }, 200);
  }

  @Watch('transaction')
  watchTransaction(transaction: Transaction) {
    if (!transaction) return;

    this.value = createReverseTransaction(transaction);

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  async save() {
    if (!this.value) return;

    this.error = null;

    return this.reverseTransaction(this.value);
  }
}
